import React, { Component } from 'react'

import BreadBottom from './BreadBottom'
import BreadTop from './BreadTop'
import Garnish from './Garnish'
import PeanutButter from './PeanutButter'

class Sandwich extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      bread: this.props.bread,
      generated: this.props.generated,
      peanutButter: this.props.peanutButter,
      garnishes: this.props.garnishes,
    };
  }

  render() {

    var layers = [];

    layers.push(
      <BreadBottom image={this.state.bread.image} name={this.state.bread.name} />
    );

    layers.push(
      <PeanutButter image={this.state.peanutButter.image} name={this.state.peanutButter.name} />
    );
    
    var garnishes = this.state.garnishes.map((garnish) =>
      <Garnish key={garnish} image={garnish.image} name={garnish.name} />
    );

    for (var i = 0; i < garnishes.length; i++) {
      layers.push(garnishes[i]);
    }

    layers.push(
      <BreadTop image={this.state.bread.image} name={this.state.bread.name} />
    );

    var sandwichClass = 'sandwich ' + (!this.state.generated ? 'is-animated' : '');
    var layerClass = 'sandwich__layer ' + (this.state.generated ? 'is-animated' : '');

    return (
      <div className={sandwichClass} >
        {layers.map((layer) => 
          <div className={layerClass} >
            {layer}
          </div>
        )}
      </div>
    );
  }
}

export default Sandwich



// WEBPACK FOOTER //
// ./src/scripts/components/Sandwich.js